<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="10" :sm="12">
            <el-form-item label="日期范围:">
              <el-date-picker
                v-model="daterange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                class="ele-fluid"
                @change="onDateRangeChoose"
              />
            </el-form-item>
          </el-col>
          <el-col :md="8" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
              <el-button
                @click="
                  (table.where = {
                    startTime: $util.toDateString(new Date(), 'yyyy-MM-dd'),
                    endTime: $util.toDateString(new Date(), 'yyyy-MM-dd'),
                  }) && $refs.table.reload()
                "
                >重置</el-button
              >
              <el-button @click="exportData" type="primary" icon="el-icon-download" class="ele-btn-icon">导出 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column header-align="center" prop="gradeName" align="center" label="年级">
            <template #default="{ row }">{{ row.branchName }}-{{ row.branchName }}</template>
          </el-table-column>
          <el-table-column header-align="center" prop="classs" align="center" label="班级总数" />
          <el-table-column header-align="center" prop="checkClasss" align="center" label="已点班级数" />
          <el-table-column header-align="center" prop="students" align="center" label="学生总数" />
          <el-table-column header-align="center" prop="checkStudents" align="center" label="异常学生总数" />
          <el-table-column label="操作" align="center" width="210px">
            <template #default="{ row }">
              <!--              <el-dropdown trigger="click" @command="getrollCallList">-->
              <!--                <span class="el-dropdown-link">操作<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i></span>-->
              <!--                <el-dropdown-menu slot="dropdown">-->
              <!--                  <el-dropdown-item command="1">已点班级</el-dropdown-item>-->
              <!--                  <el-dropdown-item command="2">异常学生名单</el-dropdown-item>-->
              <!--                </el-dropdown-menu>-->
              <!--              </el-dropdown>-->
              <el-link @click="getrollCallList(1, row.id)" icon="el-icon-user-solid" type="primary" :underline="false">已点班级</el-link>
              <el-link @click="getrollCallList(2, row.id)" icon="el-icon-user" type="primary" :underline="false">异常学生名单</el-link>
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
      <!--已点班级名单-->
      <el-dialog title="已点班级名单" :visible.sync="showClass" width="40%">
        <ele-data-table :config="classtable" :data="classList" height="calc(90vh - 261px)">
          <template #default="{ index }">
            <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
            <el-table-column prop="branch_name" label="部系" sortable="custom" />
            <el-table-column prop="grade_name" label="年级" sortable="custom" />
            <el-table-column prop="class_name" label="班级" sortable="custom" />
            <el-table-column prop="teacher_name" label="教师" sortable="custom" />
          </template>
        </ele-data-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showClass = false">取 消</el-button>
          <el-button type="primary" @click="showClass = false">确 定</el-button>
        </span>
      </el-dialog>
      <!--异常学生名单-->
      <el-dialog title="异常学生名单" :visible.sync="showStudent" width="50%">
        <ele-data-table :config="studenttable" :data="studentList" height="calc(90vh - 261px)">
          <template #default="{ index }">
            <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
            <el-table-column label="班级">
              <template #default="{ row }"> {{ row.branch_name }}-{{ row.grade_name }}-{{ row.class_name }} </template>
            </el-table-column>
            <el-table-column prop="student_name" label="学生姓名" />
            <el-table-column prop="check_type" label="学生姓名">
              <template #default="{ row }">
                {{ row.check_type === 0 ? '缺课' : row.check_type === 1 ? '请假' : '正常' }}
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="时间" />
          </template>
        </ele-data-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showStudent = false">取 消</el-button>
          <el-button type="primary" @click="showStudent = false">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
  import { exportStudentCheckRollDetails, getClasssCheckRollById, getStudentCheckRollDetailsById } from '@/config/api';

  export default {
    name: 'RollCall',
    data() {
      return {
        table: {
          // 表格配置
          url: '/studentCheckRoll/getStudentCheckRollByDate',
          where: {
            startTime: this.$util.toDateString(new Date(), 'yyyy-MM-dd'),
            endTime: this.$util.toDateString(new Date(), 'yyyy-MM-dd'),
          },
          page: false,
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            return res;
          },
        },
        choose: [], // 表格选中数据
        daterange: [new Date(), new Date()],
        showEdit: false,
        showClass: false,
        showStudent: false,
        classList: [],
        studentList: [],
        classtable: {
          page: false,
        },
        studenttable: {
          page: false,
        },
      };
    },
    methods: {
      // 日期选择改变回调
      onDateRangeChoose() {
        if (this.daterange) {
          this.table.where.startTime = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd');
          this.table.where.endTime = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd');
        } else {
          this.table.where.startTime = null;
          this.table.where.endTime = null;
        }
      },
      // 导出数据
      exportData() {
        let data = {};
        if (this.daterange) {
          data.startTime = this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd');
          data.endTime = this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd');
        } else {
          data.startTime = this.$util.toDateString(new Date(), 'yyyy-MM-dd');
          data.endTime = this.$util.toDateString(new Date(), 'yyyy-MM-dd');
        }
        exportStudentCheckRollDetails(data).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
      //
      getrollCallList(type, gradeId) {
        let data = {
          startTime: this.$util.toDateString(this.daterange[0], 'yyyy-MM-dd'),
          endTime: this.$util.toDateString(this.daterange[1], 'yyyy-MM-dd'),
          id: gradeId,
        };
        if (type === 1) {
          //已点班级
          getClasssCheckRollById(data).then((res) => {
            if (res.data.resCode == 200) {
              this.classList = res.data.data;
            }
          });
          this.showClass = true;
        }
        if (type === 2) {
          //异常学生
          getStudentCheckRollDetailsById(data).then((res) => {
            if (res.data.resCode == 200) {
              this.studentList = res.data.data;
            }
          });
          this.showStudent = true;
        }
      },
    },
  };
</script>

<style scoped>
  /deep/ .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
</style>
